import { Injectable, Injector } from '@angular/core';
import { LoggerService } from '@core/services/logger/logger.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SplunkRum } from '@splunk/otel-web';

@Injectable()
export class GlobalErrorHandlerService {
	public readonly name = 'GlobalErrorHandler';
	public readonly clientSideErrorMessage = 'Client side unhandled error';

	constructor(private injector: Injector) {}

	handleError(error: Error | HttpErrorResponse) {
		if (SplunkRum.inited) {
			SplunkRum.error(error);
		}

		if (error instanceof HttpErrorResponse) {
			// Is handled by HttpErrorInterceptor.
			return;
		}

		try {
			const logger = this.injector.get(LoggerService, null);

			if (logger?.error) {
				logger.error(this.clientSideErrorMessage, { module: this.name, error });

				return;
			}
		} catch {
			// LoggerService not available yet
		}

		// Fallback when DI is not ready (e.g., during MFE bootstrap)
		// eslint-disable-next-line no-console
		console.error(this.clientSideErrorMessage, { module: this.name, error });
	}
}
